import React, { useState, useEffect, useRef } from "react";
import { Box, Paper, IconButton, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import CalibrationGrid from "../MicroTip/CalibrationData";
import PropertiesForm from "../MicroTip/Parameters";
import Header from "../MicroTip/Header";
import History from "../MicroTip/History"
import Splines from "../MicroTip/Splines"
import { getInitialState } from "./DefaultParameters";

export default function CollapsibleVerticalLayout() {

    // Separate states
    const [isResultsCollapsed, setResultsCollapsed] = useState(true); // default collapsed
    const [isCalibrationCollapsed, setCalibrationCollapsed] = useState(false);
    const [isParametersCollapsed, setParametersCollapsed] = useState(false);
    const [isSplineCollapsed, setSplineCollapsed] =        useState(false);
    const [selectedModel, setSelectedModel] = useState("0");
    const [rows, setRows] = useState(Array.from({ length: 5 }, () => ({ conc: "", resp: "" })));
    const [parameters, setParameters] = useState(getInitialState());
    const [resultDataMap, setResultDataMap] = useState(() => {
        const saved = sessionStorage.getItem("calibrationHistory");
        return saved ? JSON.parse(saved) : {};
    });
    const resultsRef = useRef(null);
    useEffect(() => {
        const hasData = resultDataMap && Object.keys(resultDataMap).length > 0;

        if (hasData) {
            setResultsCollapsed(false);
        }
    }, [resultDataMap]);
    useEffect(() => {
        console.log("TXBVersion =", parameters?.TXBVersion);
    }, [parameters]);
    return (
        <div>
            {/* Pass callback to Header */}
            <Header
                rows={rows}
                parameters={parameters}
                setParameters={setParameters}
                setResultDataMap={setResultDataMap}
                selectedModel={selectedModel}
                setSelectedModel={setSelectedModel}
                onCalibrate={() => {

                   
                    setCalibrationCollapsed(true);
                    setParametersCollapsed(true);                    
                    setResultsCollapsed(false);
                    
                    setTimeout(() => {
                        resultsRef.current?.scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                        });
                    }, 150);
                }}
            />

            <Box display="flex" flexDirection="column" padding={2}>

                {/* ================= SPLINES PANEL ================= */}
                { String(parameters?.TXBVersion) === "4" && (
                    <Paper
                        elevation={3}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            mt: 0
                        }}
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            bgcolor="#774def"
                            color="#ffffff"
                            px={2}
                            py={1}
                        >
                            <Typography variant="subtitle1">
                                Splines
                            </Typography>

                            <IconButton
                                size="small"
                                onClick={() =>
                                    setSplineCollapsed(!isSplineCollapsed)
                                }
                                sx={{ color: "white" }}
                            >
                                {isSplineCollapsed ? (
                                    <ExpandMore />
                                ) : (
                                    <ExpandLess />
                                )}
                            </IconButton>
                        </Box>

                        <Box
                            p={2}
                            sx={{
                                display: isSplineCollapsed
                                    ? "none"
                                    : "block"
                            }}
                        >
                            <Splines />
                        </Box>
                    </Paper>
                )}

                {/* ================= CALIBRATION PANEL ================= */}
                <Paper elevation={3} sx={{ display: "flex", flexDirection: "column", mt: 2 }}>

                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        bgcolor="#774def"
                        color="#ffffff"
                        px={2}
                        py={1}
                    >
                        <Typography variant="subtitle1">Calibration Data</Typography>
                        <IconButton
                            size="small"
                            onClick={() => setCalibrationCollapsed(!isCalibrationCollapsed)}
                            sx={{ color: "white" }}
                        >
                            {isCalibrationCollapsed ? <ExpandMore /> : <ExpandLess />}
                        </IconButton>
                    </Box>

                    <Box
                        flex={1}
                        overflow="auto"
                        p={2}
                        sx={{
                            display: isCalibrationCollapsed ? "none" : "block",
                        }}
                    >
                        <CalibrationGrid rows={rows} setRows={setRows} />
                    </Box>
                </Paper>

                {/* ================= PARAMETERS PANEL ================= */}
                <Paper elevation={3} sx={{ display: "flex", flexDirection: "column", mt: 2 }}>

                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        bgcolor="#774def"
                        color="#ffffff"
                        px={2}
                        py={1}
                    >
                        <Typography variant="subtitle1">Parameters</Typography>
                        <IconButton
                            size="small"
                            onClick={() => setParametersCollapsed(!isParametersCollapsed)}
                            sx={{ color: "white" }}
                        >
                            {isParametersCollapsed ? <ExpandMore /> : <ExpandLess />}
                        </IconButton>
                    </Box>

                    <Box
                        flex={1}
                        overflow="auto"
                        p={2}
                        sx={{
                            display: isParametersCollapsed ? "none" : "block",
                        }}
                    >
                        <PropertiesForm
                            parameters={parameters}
                            setParameters={setParameters}
                        />
                    </Box>
                </Paper>

                {/* ================= RESULTS PANEL ================= */}
                <Paper
                    ref={resultsRef}
                    elevation={3}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        mt: 2,
                    }}
                >

                    {/* Header */}
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        bgcolor="#774def"
                        color="#ffffff"
                        px={2}
                        py={1}
                    >
                        <Typography variant="subtitle1">Results</Typography>
                        <IconButton
                            size="small"
                            onClick={() => setResultsCollapsed(!isResultsCollapsed)}
                            sx={{ color: "white" }}
                        >
                            {isResultsCollapsed ? <ExpandMore /> : <ExpandLess />}
                        </IconButton>
                    </Box>

                    {/* Content */}
                    <Box
                        flex={1}
                        overflow="auto"
                        p={2}
                        sx={{
                            display: isResultsCollapsed ? "none" : "block",
                        }}
                    >
                        <History
                            resultDataMap={resultDataMap}
                        setResultDataMap={setResultDataMap}
                            rows={rows}
                            parameters={parameters}
                        />

                    </Box>
                </Paper>
            </Box>
        </div>
    );
}